export default {
  description:
    "{{name}} in {{city}}. Offizielle Menü Karte. Spare Geld und bestelle hier online.",
};
